// extracted by mini-css-extract-plugin
export default {"container":"PageSpinner_container__dHN3q"};